module.exports = __webpack_public_path__ + "static/media/excel_down.3b5e78ec.png";